import { useEffect } from "react";
import TagManager from "react-gtm-module";
import { GTM_ID } from "@/constants";

export const useGoogleAnalytics = () => {
  /*const checkIfAnalyticsLoaded = () => {
    return new Promise((_resolve, _reject) => {
      const timeStart = Date.now();
      const TIMEOUT = 5000;

      const isLoaded = function () {
        if (Date.now() - timeStart > TIMEOUT) {
          _reject("Timeout expired. Google analytics not loaded.");
        }

        if (
          window?.dataLayer &&
          isArray(window.dataLayer) &&
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          window.dataLayer.findIndex((x) => x?.event === "gtm.load") > -1
        ) {
          _resolve(true);
        } else {
          setTimeout(isLoaded, 500);
        }
      };

      isLoaded();
    }).catch((_err) => {
      Sentry.captureException(_err);
    });
  };*/

  useEffect(() => {
    void (() => {
      if (GTM_ID) {
        TagManager.initialize({
          gtmId: GTM_ID,
        });

        //await checkIfAnalyticsLoaded();
      }
    })();
  });
};
